import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CoreDialog,
    {
      attrs: {
        "data-qa": "doctor-avatar-editor-preview",
        value: _vm.value,
        size: _setup.isMobile ? "fullscreen" : "xl",
        title: _vm.title,
        "min-height": _setup.isMobile ? undefined : "650px",
        divider: "",
        persistent: "",
      },
      scopedSlots: _vm._u(
        [
          {
            key: "prependBtn",
            fn: function ({ btnProps }) {
              return [
                _c(
                  VBtn,
                  _vm._b(
                    {
                      on: {
                        click: function ($event) {
                          return _setup.emit("cancel")
                        },
                      },
                    },
                    "v-btn",
                    btnProps,
                    false
                  ),
                  [_c("span", { staticClass: "ui-icon-close-not-a-circle" })]
                ),
              ]
            },
          },
          !_vm.isLoading
            ? {
                key: "actions",
                fn: function () {
                  return [
                    _c(
                      VBtn,
                      {
                        class: { "flex-grow-1 w-0": _setup.isMobile },
                        attrs: { color: "text", text: "" },
                        on: {
                          click: function ($event) {
                            return _setup.emit("cancel")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n      " +
                            _vm._s(_setup.t("Отменить", _setup.l10nOptions)) +
                            "\n    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      VBtn,
                      {
                        class: { "flex-grow-1 w-0": _setup.isMobile },
                        attrs: { color: "primary", depressed: "" },
                        on: {
                          click: function ($event) {
                            return _setup.emit("submit")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n      " +
                            _vm._s(_setup.t("Отправить", _setup.l10nOptions)) +
                            "\n    "
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              }
            : null,
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass:
                "d-flex flex-column justify-center align-center flex-grow-1",
            },
            [
              _c(VProgressCircular, {
                attrs: { color: "primary", size: "48", indeterminate: "" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "text-body-2 text--text mt-4" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _setup.t(
                        "Обрабатываем искусственным интеллектом",
                        _setup.l10nOptions
                      )
                    ) +
                    "\n    "
                ),
              ]),
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass:
                "doctor-avatar-editor-modal d-flex flex-column align-center flex-shrink-0 flex-grow-1",
            },
            [
              !_vm.isStaff
                ? _c(
                    "div",
                    {
                      staticClass:
                        "doctor-avatar-editor-modal__info mb-4 w-100 pa-4 text-body-2 text--text",
                      class: _setup.isMobile ? "mx-2" : "",
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _setup.t(
                              "Фото обработано. Если с фотографией что-то не так, загрузите другую.",
                              _setup.l10nOptions
                            )
                          ) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(VImg, {
                staticClass: "flex-grow-0",
                class: _setup.isMobile ? "mb-4" : "mb-2",
                attrs: {
                  height: "300",
                  width: "300",
                  src: _vm.imageSrc,
                  alt: "",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex mb-6" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "pa-0 mr-2",
                      attrs: {
                        color: "white",
                        width: "36",
                        "min-width": "36",
                        height: "36",
                        elevation: "1",
                      },
                      on: {
                        click: function ($event) {
                          return _setup.emit("rotate-clockwise")
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { color: "primary" } }, [
                        _vm._v("\n          ui-icon-undo\n        "),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    VBtn,
                    {
                      staticClass: "pa-0",
                      attrs: {
                        color: "white",
                        width: "36",
                        "min-width": "36",
                        height: "36",
                        elevation: "1",
                      },
                      on: {
                        click: function ($event) {
                          return _setup.emit("rotate-counter-clockwise")
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { color: "primary" } }, [
                        _vm._v("\n          ui-icon-redo\n        "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm.isStaff
                    ? _c(VSwitch, {
                        staticClass: "mb-6 mt-0 pt-0",
                        attrs: { "hide-details": "", inset: "" },
                        on: {
                          change: function ($event) {
                            return _setup.emit(
                              "switch-crop-photo",
                              _setup.isCropPhoto
                            )
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c(
                                    "span",
                                    { staticClass: "text-body-1 text--text" },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _setup.t(
                                              "Обтравить фото",
                                              _setup.l10nOptions
                                            )
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2612684034
                        ),
                        model: {
                          value: _setup.isCropPhoto,
                          callback: function ($$v) {
                            _setup.isCropPhoto = $$v
                          },
                          expression: "isCropPhoto",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isUpscalingEnabled
                    ? _c(VSwitch, {
                        staticClass: "mb-6 mt-0 pt-0",
                        attrs: { "hide-details": "", inset: "" },
                        on: {
                          change: function ($event) {
                            return _setup.emit(
                              "switch-upscale-photo",
                              _setup.isUpscalePhoto
                            )
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c(
                                    "span",
                                    { staticClass: "text-body-1 text--text" },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _setup.t(
                                              "Включить улучшение",
                                              _setup.l10nOptions
                                            )
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _setup.t(
                                              "изображения",
                                              _setup.l10nOptions
                                            )
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1623989602
                        ),
                        model: {
                          value: _setup.isUpscalePhoto,
                          callback: function ($$v) {
                            _setup.isUpscalePhoto = $$v
                          },
                          expression: "isUpscalePhoto",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }